// 销售状态部分1
// 容错处理，确保 window.ProductSalesStatus 已定义
if (!window.ProductSalesStatus) {
  window.ProductSalesStatus = {
    updateStatus: function () {},
    init: function () {}
  };
} else if (typeof window.ProductSalesStatus === "function") {
  window.ProductSalesStatus = new window.ProductSalesStatus();
}

class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.main = this.closest('main-product');
    this.addEventListener('change', this.onVariantChange);
    this.updateCode();
    this.getBulkSaleData();
  }

  /**
   * 更新变体
   */
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', '');
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', '');
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateSquarePlacement();
      // 销售状态部分2
      window.ProductSalesStatus.updateStatus(this.currentVariant.id, this.currentVariant);
    }
    this.updateCode();
    this.updateBulkSale()
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('[data-options]'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  /**
   * 跟新变体图片 —— 派发自定义事件，由 product-media-gallery Custom Element 监听处理
   */
  updateMedia() {
    if (this.currentVariant?.featured_media) {
      document.dispatchEvent(new CustomEvent('product:media-update', {
        detail: {
          mediaId: this.currentVariant.featured_media.id,
          variantId: this.currentVariant.id
        }
      }))
    }
  }

  /**
   * 更新网址的链接
   */
  updateURL() {
    if (!this.currentVariant || location.pathname.indexOf('/products/') === -1) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  /**
   * 更新快速结账匹配产品ID
   */
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }

  /**
   * 修复 square-placement 分期付款组件切换变体后隐藏的问题。
   *
   * 问题根因：shopify-afterpay-javascript.js 会在检测到 input[name="id"] 的 change 事件后
   * 异步（约 200ms）更新 square-placement 的 data-amount 等属性，
   * Square 组件的 attributeChangedCallback 检测到变化后通过 element.style.display = 'none'
   * 进入重验证流程并隐藏自身，但"恢复显示"的回调不会执行。
   *
   * 注意：style.display 通过 CSSOM 设置不会触发 MutationObserver 的 style 属性变化，
   * 因此不能用 MutationObserver 拦截。
   *
   * 解决方案：在 Afterpay 异步操作完成后（500ms）直接移除 display:none。
   * 经验证，Afterpay 只会设置一次 display:none 且不会在我们移除后重新设置。
   */
  updateSquarePlacement() {
    setTimeout(() => {
      document.querySelectorAll('square-placement').forEach((el) => {
        if (el.style.display === 'none') {
          el.style.removeProperty('display');
        }
      });
    }, 500);
  }

  /**
   * 更新产品状态
   * @returns {Promise<void>}
   */
  async renderProductInfo() {
    const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
    const id = `price-${this.dataset.section}`;
    const destination = document.getElementById(id);

    this.source = await fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        return html.getElementById(id);
      });

    if (this.source && destination) destination.innerHTML = this.source.innerHTML;

    document.getElementById(`price-${this.dataset.section}`).classList.remove('visibility-hidden');

    document.dispatchEvent(
      new CustomEvent('product:price-updated', {
        detail: {
          variantId: this.currentVariant.id,
          sectionId: this.dataset.section
        }
      })
    );

    // this.updateIntegral();
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
  }

  // 更新积分
  updateIntegral() {
    var priceInCents = Math.floor(this.currentVariant.price / 100);
    var priceInCentsElement = document.querySelector('.price-in-cents');
    var priceTimesElement = document.querySelector('.price-in-cents-times');
    var integralTimes = parseFloat(priceTimesElement.getAttribute('data-integral-times'));

    var newPriceInCents = integralTimes * priceInCents;
    if(priceTimesElement) priceTimesElement.textContent = newPriceInCents;
    if(priceInCentsElement) priceInCentsElement.textContent = priceInCents;
  }

  toggleAddButton(disable = true, btnext, status) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
    const addButtonInnerHtml = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]').querySelector('span');

    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', true);
      if (btnext) addButtonInnerHtml.textContent = btnext;
    } else {
      addButton.removeAttribute('disabled');
      addButtonInnerHtml.textContent = window.variantStrings.addToCart;
    }
  }

  /**
   * 变体不存在时禁用按钮和价格
   */
  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
    const addButtonInnerHtml = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]').querySelector('span');
    if (!addButton) return;
    addButtonInnerHtml.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`).classList.add('uk-hidden');
  }

  /**
   * 获取产品json并缓存
   * @returns {*}
   */
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  /**
   * 购物车超过库存数量时提示错误信息
   */
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('bluetti-product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  /**
   * 变体折扣码
   */
  updateCode() {
    let tm_discount = this.main.querySelector('.tm-discount-variant')
    let tm_discount_code =  this.main.querySelector('.tm-discount-code')
    let tm_discount_date =  this.main.querySelector('.tm-discount-date')
    let tm_discount_des =  this.main.querySelector('.tm-discount-des')
    let tm_discount_coupon =  this.main.querySelector('.tm-discount-coupon')
    const url = window.location.href;
    const { url: urlWithoutParams, paramValue } = this.parseUrl(url, 'variant');
    fetch(`${urlWithoutParams}?view=json`)
    .then(response => response.json())
    .then(responseData => {
      // 在此处对 responseData 进行处理
      if(responseData && responseData.coupon != null) {
        let coupon = responseData.coupon
        const foundObjs = coupon.filter(obj => obj.hasOwnProperty(paramValue));
        if(foundObjs.length <= 0 || tm_discount == null) return;

        if(foundObjs[0][paramValue] != null) {
            tm_discount.setAttribute("style", "display: block !important")
            tm_discount.dataset.discount = foundObjs[0][paramValue].code;
            tm_discount_code.innerHTML = foundObjs[0][paramValue].code;
            tm_discount_date.innerHTML = foundObjs[0][paramValue].start + '~' + foundObjs[0][paramValue].end;
            tm_discount_des.innerHTML = foundObjs[0][paramValue].des;
            tm_discount_coupon.innerHTML = foundObjs[0][paramValue].coupon;
        }else {
          tm_discount.setAttribute("style", "display: none !important")
        }
      }else {
        tm_discount.setAttribute("style", "display: none !important")
      }
    });
  }
  removeQueryParams(url) {
    const index = url.indexOf('?');
    if (index !== -1) {
      return url.substring(0, index);
    } else {
      return url;
    }
  }
  parseUrl(url, paramName) {
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.search);
    const paramValue = params.get(paramName);
    return {
      url: urlObj.origin + urlObj.pathname,
      paramValue: paramValue
    };
  }

  // 初始化小B折扣信息
  getBulkSaleData() {
    // 小b折扣数据
    this.bulkSaleData = this.getAttribute('data-bulk-sale').split(';').map(str => {
      return {
        id: str.split(',')[0].trim(),
        bulk_sale: (str.split(',')[1] || '').trim()
      }
    });
    const variants = this.getVariantData();
    let variantIdFromUrl = null;
    // 获取 URL 里的 variant 参数
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('variant')) {
      variantIdFromUrl = urlParams.get('variant');
    }
    // 根据 variantIdFromUrl 查找变体
    if (variants && variants.length > 0) {
      if (variantIdFromUrl) {
        const found = variants.find(v => String(v.id) === String(variantIdFromUrl));
        this.currentVariant = found || variants[0];
      } else {
        this.currentVariant = variants[0];
      }
      this.updateBulkSale();
    }
  }
  // 更新小B折扣信息
  updateBulkSale() {
    const currentVariantId = this.currentVariant.id;
    const meta = this.bulkSaleData.find(v => v.id == currentVariantId);
    const container = document.getElementById('bulk-sale-info');
    if (!container) return;
    if (!meta || !meta.bulk_sale || meta.bulk_sale === 'null') {
      container.innerHTML = '';
      return;
    }
    if (container) {
      if (meta && meta.bulk_sale) {
        const lines = meta.bulk_sale.split('^');
        let html = '<ul class="flex flex-col gap-y-2 lg:gap-y-3 px-[14px] lg:px-6 pt-[14px] lg:pt-6 pb-[6px] lg:pb-3 lg:my-10 bg-[#FAFAFC] rounded-lg">';
        lines.forEach((line, idx) => {
          const parts = line.split('*');
          const qty_range = parts[0];
          const discount_full = parts[1] || '';
          const label_parts = discount_full.split('-');
          html += `<li class="flex justify-between pb-2 lg:pb-3 ${idx < lines.length - 1 ? 'border-b' : ''}" style="border-color: #E9E9ED;">
            <span class="text-gray-700 text-sm lg:text-base">${qty_range}</span>
            <span class="text-sm lg:text-base font-normal text-[#FF9500]">
              <span class="text-base lg:text-lg lg:mr-1 font-semibold">${label_parts[0] || ''}</span>
              ${label_parts[1] || ''}
            </span>
          </li>`;
        });
        html += '</ul>';
        container.innerHTML = html;
      } else {
        container.innerHTML = '';
      }
    }
  }
}


if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}
class MainProduct extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slideshowElement: this.querySelector('[uk-slideshow]'),
      sliderElement: this.querySelector('[uk-slider]'),
    }

    this.thumbnailImageClick();

    // 销售状态部分3
    window.ProductSalesStatus.init();
  }

  thumbnailImageClick() {
    const oLis = UIkit.util.queryAll('[uk-slider] [data-index]');
    UIkit.util.on(oLis, 'click', event => this.thumbnailImageSlide(event.target.dataset.thumbnailId))
  }

  /**
   * 修复滚动提示
   */
  thumbnailImageSlide(id) {
    const newMedia = this.querySelector(`[data-media-id="${id}"]`);
    if (!newMedia) return;
    UIkit.util.removeClass(UIkit.util.queryAll('[uk-slider] [data-thumbnail-id]'), 'tm-active');
    this.querySelector(`[data-thumbnail-id="${id}"]`).classList.add('tm-active');
    UIkit.slideshow(this.selectors.slideshowElement).show(newMedia.dataset.imageIndex);
    UIkit.slider(this.selectors.sliderElement).show(newMedia.dataset.imageIndex);
  }
}

if (!customElements.get('main-product')) {
  customElements.define('main-product', MainProduct);
}
